


































import Vue from 'vue';

/**
 * Seperates out the table headers so they can be used in a 'fake' table
 */
export default Vue.extend({
  props: {
    /**
     * Makes the item a button that emits "changeSorting" on click.
     * When used, the isSorted and sortedAsc props are required
     */
    sortable: {
      type: Boolean,
      default: false,
    },
    /**
     * Requires `sortable` prop to be set.
     * It's up to the parent component to do the logic for this
     */
    isSorted: {
      type: Boolean,
      default: false,
    },
    /**
     * Requires `sortable` prop to be set.
     * It's up to the parent component to do the logic for this
     */
    sortedAsc: {
      type: Boolean,
      default: false,
    },
    /**
     * Reduces the height for a smaller table
     */
    dense: {
      type: Boolean,
      default: false,
    },
    /**
     * e.g. kts, kg, UTC
     */
    unit: {
      type: String,
      required: false,
    },
    /**
     * Show either the unit or a blank space to align with other headers that have a unit.
     * The same value should be passed to all table headers in a table
     */
    showUnit: {
      type: Boolean,
      default: false,
    },
  },
  data(): any {
    return {};
  },
  computed: {
    component(): string {
      return this.sortable ? 'button' : 'span';
    },
  },
  methods: {
    handleClick(): void {
      if (!this.sortable) return;
      this.$emit('changeSorting');
    },
  },
});
